import Login from "../views/Login";

const LoginPage = () => {
  return (
    <div className="h-screen">
      <Login />
    </div>
  );
};

export default LoginPage;
